import { MessageVarsT } from '@interfaces/message-vars.type';
import { TranslatableVarI } from '@interfaces/translatable-var.interface';
import { TranslateService } from '@ngx-translate/core';

export function resolveMessageVars(translate: TranslateService, vars?: MessageVarsT): Record<string, any> | undefined {
  if (!vars) {
    return undefined;
  }

  const resolved: Record<string, any> = {};

  Object.entries(vars).forEach(([name, value]) => {
    if (value && typeof value === 'object' && 'key' in value) {
      const translatable = value as TranslatableVarI;
      resolved[name] = translate.instant(translatable.key, translatable.vars);
    } else {
      resolved[name] = value;
    }
  });

  return resolved;
}
